var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',_vm._b({ref:"myChart",staticClass:"chart",attrs:{"option":_vm.option}},'v-chart',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }